import { ROOT_URL } from '../actions';

export const cargoScanApi = {
  GET_CARGO_DETAILS: `${ROOT_URL}/hms/get_cargo_details/`,
  PROCESS_SCANNED_ORDERS: `${ROOT_URL}/hms/process_scanned_orders/`,
  PROCESS_SCANNED_ARRIVAL_BREAK_ORDERS: `${ROOT_URL}/hms/process_scanned_cargos/`,
  UPLOAD_CARGO_PHOTOS: `${ROOT_URL}/hms/upload_image_for_cargo_reconciliation/`,
  SEE_PHOTOS: `${ROOT_URL}/hms/get_image_for_cargo_reconciliation/`,
}